import artLogo from "../images/teamlogos/art.png";
import btvLogo from "../images/teamlogos/btv.png";
import dtvLogo from "../images/teamlogos/dtv.png";
import fcjLogo from "../images/teamlogos/fcj.png";
import mindenLogo from "../images/teamlogos/minden.png";
import ptsvLogo from "../images/teamlogos/ptsv.svg";
import sgcoeLogo from "../images/teamlogos/sgcoe.svg";
import solingenLogo from "../images/teamlogos/solingen.svg";
import ssfbonnLogo from "../images/teamlogos/ssfbonn.png";
import tpbLogo from "../images/teamlogos/tpb.svg";
import tsvgwLogo from "../images/teamlogos/tsvgw.png";
import tvaLogo from "../images/teamlogos/tva.jpg";
import vvhLogo from "../images/teamlogos/vvh.png";

const ICON_MAP = {
  "21979628": artLogo,
  "21416996": btvLogo,
  "21416988": dtvLogo,
  "21979631": fcjLogo,
  "21979595": mindenLogo,
  "21417019": ptsvLogo,
  "21416979": sgcoeLogo,
  "21979627": solingenLogo,
  "21979625": ssfbonnLogo,
  "21416981": tpbLogo,
  "21979602": tsvgwLogo,
  "21416998": tvaLogo,
  "21417000": vvhLogo,
};

const getTeamLogoById = (id) => {
  if (id == null || ICON_MAP[id] == null) {
    console.warn("Could not find team logo with id", id);
    return null;
  }
  return ICON_MAP[id];
};

const sams = {
  getTeamLogoById,
};

export default sams;
